export const LOGO_URL = "/brand/title-logo.png";

export const HERO_IMAGES = [
    "/brand/hero1.jpg",
    "/brand/hero2.jpg",
    "/brand/hero3.jpg",
];

export const BRAND = {
    name: "BENNE",
    mission: "Amplifying Underrepresented Voices in Food & Hospitality",
    socials: [
        {
            name: "Instagram",
            icon: "Instagram",
            href: "https://www.instagram.com/bennebrandsmedia",
        },
        {
            name: "Bluesky",
            icon: "Cloud",
            href: "https://bsky.app/profile/bennebrands.bsky.social",
        },
        {
            name: "Threads",
            icon: "AtSign",
            href: "https://www.threads.com/@bennebrandsmedia",
        },
        {
            name: "LinkedIn",
            icon: "Linkedin",
            href: "https://www.linkedin.com/company/bennebrands",
        },
    ],
};

/**
 * Main navigation menu. Top-level items may include `children` for dropdowns.
 */
export const NAV_LINKS = [
    { label: "Home", to: "/" },
    {
        label: "Submit a Press Release",
        to: "/submit-press-release",
        children: [
            { label: "Billing", to: "/submit-press-release/billing" },
            { label: "FAQs", to: "/submit-press-release/faqs" },
        ],
    },
    {
        label: "About",
        to: "/about",
        children: [
            { label: "Mission", to: "/about/mission" },
            { label: "Privacy", to: "/about/privacy" },
            { label: "Terms & Conditions", to: "/about/terms" },
        ],
    },
    { label: "Categories", to: "/categories" },
    { label: "Events", to: "/events" },
    { label: "Subscribe", to: "/subscribe" },
    { label: "Contact", to: "/contact" },
];

/**
 * Full post category list. Order matters — this is the canonical order shown
 * in the Categories index and the admin Select dropdown.
 */
export const POST_CATEGORIES = [
    "Announcement",
    "Awards",
    "Beverage(s) (Non-alcohol)",
    "Conference",
    "Entertainment (Hospitality)",
    "Food Festival/Event",
    "Fundraiser",
    "Hospitality",
    "Hotel/Accommodations",
    "Keynote Speaker",
    "Launch",
    "Leadership Announcement",
    "New Position",
    "Obituary",
    "Pop-up",
    "Press",
    "Promotion/Sale/Discount",
    "Restaurant/Hospitality Launch",
    "Retail",
    "Tourism",
    "Travel",
    "Venue",
    "Wine + Spirits (21+ over )",
    "Workshop",
];

const PALETTE = [
    { bg: "#E63B26", color: "#FFFFFF" }, // coral
    { bg: "#54547A", color: "#FFFFFF" }, // navy
    { bg: "#F5C53D", color: "#1B1B1B" }, // yellow
    { bg: "#A89489", color: "#FFFFFF" }, // taupe
    { bg: "#B8C0A8", color: "#1B1B1B" }, // sage
    { bg: "#1B1B1B", color: "#F5C53D" }, // black w/ yellow text
];

const pick = (key) => {
    let h = 0;
    for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
    return PALETTE[h % PALETTE.length];
};

/**
 * Returns inline-style {background, color} for any category string.
 * Stable color-by-name hash across renders.
 */
export const categoryStyle = (cat) => {
    if (!cat) return { background: "#E63B26", color: "#FFFFFF" };
    const { bg, color } = pick(cat);
    return { background: bg, color };
};

// Backwards-compat (still used by some places to keep classNames clean).
export const CATEGORY_CLASS = {
    OPENING: "badge-opening",
    AWARD: "badge-award",
    EVENT: "badge-event",
    REVIEW: "badge-review",
    INTERVIEW: "badge-interview",
};
